export default "__VITE_ASSET__a7609912__"